// extracted by mini-css-extract-plugin
module.exports = {"staticPagesMenu":"styles_staticPagesMenu__YuC66","staticPagesMenuItem":"styles_staticPagesMenuItem__xalIf","active":"styles_active__RYIT6"};